import { __rest } from "tslib";
import React, { useEffect } from 'react';
import { motion, useAnimation } from 'framer-motion';
import Animated, { AnimationType } from '../Animated';
import { AnimationState } from '../constants';
const AnimatedList = (_a) => {
    var { displayShowMoreButton, showMoreButton, children } = _a, restProps = __rest(_a, ["displayShowMoreButton", "showMoreButton", "children"]);
    const listControls = useAnimation();
    const buttonControls = useAnimation();
    useEffect(() => {
        listControls.start(AnimationState.visible);
        buttonControls.start(AnimationState.visible);
    }, [children, buttonControls, listControls]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Animated, Object.assign({ Component: motion.ul, animation: AnimationType.staggerChildren, "data-testid": "list", animate: listControls, initial: AnimationState.hidden }, restProps), children),
        displayShowMoreButton && (React.createElement(Animated, { Component: motion.div, animation: AnimationType.falling, animate: buttonControls, initial: AnimationState.hidden }, showMoreButton))));
};
export default AnimatedList;
//# sourceMappingURL=AnimatedList.js.map